module.exports = "https://static.wanderu.com/static/media/chiku-desktop.671f49fd.svg";